(function () {
  angular.module('MktzapApp.Controllers')
    .controller('NacWhiteListController', nacWhiteListController);

  nacWhiteListController.$inject = ['$scope', 'NacWhiteListService', 'FoundationApi', 'NotificationService', 'LangService', '$rootScope', 'ngTableParams'];

  function nacWhiteListController($scope, NacWhiteListService, FoundationApi, NotificationService, LangService, $rootScope, ngTableParams) {
    var vm = this;
    vm.tableWhiteLists = [];
    vm.whiteLists = {};
    vm.whiteList = {};
    vm.whiteListEdit = {};
    vm.whiteListFilter = {};
    vm.whiteListDeleteId = null;

    LangService
      .getPageLabels({ 'page': 'menu.channelsPlugin.nacWhiteList' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.cleanFilter = function () {
      vm.whiteListFilter = {};
      vm.filterWhiteLists();
    }

    vm.filterWhiteLists = function () {


      vm.whiteListTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          let filters = {
            page: params.url().page,
            ...vm.whiteListFilter
          }

          NacWhiteListService
            .filterWhiteLists(filters)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(data.data);
                params.total(data.total);
                vm.totalWhiteLists = data.total;
                vm.tableWhiteLists = data.data;
              } else {
                NotificationService.errorHandler(data, vm.labels.errorGetInfo);
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, vm.labels.errorOperation);
            });
        }
      })
    }

    function getWhiteLists() {
      vm.filterWhiteLists();
    }

    getWhiteLists();

    vm.addWhiteListModal = function () {
      vm.whiteList = {};
      FoundationApi.publish('registerWhiteListModal', 'open');
    }

    vm.editWhiteListModal = function (whiteListId) {
      vm.whiteListEdit = {};
      NacWhiteListService
        .getWhiteListById({ id: whiteListId })
        .$promise
        .then(function (data) {
          if (data.whiteList) {
            vm.whiteListEdit = data.whiteList;
            vm.whiteListEdit.id = data.whiteList._id;
            FoundationApi.publish('editWhiteListModal', 'open');
          } else {
            NotificationService.errorHandler(data, vm.labels.error);
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.error);
        });
    }

    vm.confirmDeleteModal = function (whiteListId) {
      vm.whiteListDeleteId = whiteListId;
      FoundationApi.publish('confirmDeleteWhiteListModal', 'open');
    }

    vm.saveWhiteList = function (save = true) {
      whiteListExist(save).then(function (exist) {
        if (exist.whiteList == null) {
          if (save) {
            vm.save();
          } else {
            vm.saveEdit();
          }
        } else if (exist.whiteList._id == vm.whiteListEdit.id) {
          vm.saveEdit();
        } else {
          NotificationService.errorHandler([], vm.labels.alertErrorNumWhiteListExist);
        }
      });
    }

    vm.save = function () {

      if (!vm.whiteList.companyCode || !vm.whiteList.attendanceType || !vm.whiteList.groupCode || !vm.whiteList.groupName || !vm.whiteList.tradingName) {
        NotificationService.errorHandler([], vm.labels.alertErrorInputsEmpaty);
        return;
      }

      if (!vm.whiteList.companyCode.match(/^\d{1,10}$/g)) {
        NotificationService.errorHandler([], vm.labels.alertErrorValidationCompanyCode);
        return;
      }

      if (!vm.whiteList.groupCode.match(/^\d{1,10}$/g)) {
        NotificationService.errorHandler([], vm.labels.alertErrorValidationGroupCode);
        return;
      }

      NacWhiteListService
        .store(vm.whiteList)
        .$promise
        .then(function (data) {
          getWhiteLists();
          vm.whiteList = {};
          NotificationService.successHandler([], vm.labels.dataSaved);
          FoundationApi.publish('registerWhiteListModal', 'close');
        }).catch(function () {
          NotificationService.errorHandler([], vm.labels.errorOperation);
        });
    }

    vm.delete = function () {
      NacWhiteListService
        .delete({ id: vm.whiteListDeleteId })
        .$promise
        .then(function (data) {
          getWhiteLists();
          if (data.success) {
            vm.whiteListDeleteId = null;
            NotificationService.successHandler(data, vm.labels.successDelData);
            FoundationApi.publish('confirmDeleteWhiteListModal', 'close');
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.internalServerError);
        });
    }

    function whiteListExist(save) {
      if (save) {
        save = { companyCode: vm.whiteList.companyCode };
      } else {
        save = { companyCode: vm.whiteListEdit.companyCode };
      }

      return NacWhiteListService
        .getExistsCompanyCode(save)
        .$promise.catch(function () {
          NotificationService.errorHandler([], vm.labels.alertErrorQueryWhiteList);
        });
    }

    vm.saveEdit = function (data) {

      if (!vm.whiteListEdit.companyCode || !vm.whiteListEdit.attendanceType || !vm.whiteListEdit.groupCode || !vm.whiteListEdit.groupName || !vm.whiteListEdit.tradingName) {
        NotificationService.errorHandler([], vm.labels.alertErrorInputsEmpaty);
        return;
      }

      if (!vm.whiteListEdit.companyCode.match(/^\d{1,10}$/g)) {
        NotificationService.errorHandler([], vm.labels.alertErrorValidationCompanyCode);
        return;
      }

      if (!vm.whiteListEdit.groupCode.match(/^\d{1,10}$/g)) {
        NotificationService.errorHandler([], vm.labels.alertErrorValidationGroupCode);
        return;
      }

      NacWhiteListService
        .update(vm.whiteListEdit)
        .$promise
        .then(function (data) {
          getWhiteLists();
          vm.whiteListEdit = {};
          NotificationService.successHandler(data, vm.labels.updatedWithSuccess);
          FoundationApi.publish('editWhiteListModal', 'close');
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.internalServerError);
        });
    }

  }
})();
